/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React,{useState} from 'react'
import { PriceSlider } from './PriceSlider';
import "rc-slider/assets/index.css";
import { exceptThisSymbols } from '../../constants';
import Modal from 'react-modal';
import HeaderContext from '../../Components/Context/HeaderContext';
import { useContext } from 'react';
import CategoryManager from './CategoryManager';
import CustomFilter from './CustomFilters';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};
Modal.setAppElement('body');

export default function ResposiveFilterModal({
    setpriceRange,
    priceRange,
    Size,
    setSize,
    handleApply,
    Segments,
    handleCheckBox,
    setresposivePopup,
    result,
    offers,
    handleClear,
    sizeList,
    lengthList,
    filterParam,
    payload,
}) {
    const {isPopup,
        setisPopup} = useContext(HeaderContext);
    setisPopup(true)
    const tabs=['Categories', 'Size(mm)', 'Price range'];
    const [selected, setselected] = useState(result?.length>0? 'Categories': 'Size(mm)');
    const handleClose=()=>{
        setisPopup(false);
        setresposivePopup(false)
    }
    return (
        <div className=" fade fixed top-0 left-0 show w-full h-full outline-none overflow-x-hidden overflow-y-auto" id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <Modal 
                isOpen={true}
                // onAfterOpen={afterOpenModal}
                style={customStyles}
            >
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current" style={{width:'400px'}}>
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button type="button"
                            onClick={()=>handleClose()}
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-1 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal" aria-label="Close" style={{cursor:'pointer',opacity:'1'}}>
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-9 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[25%]" id="pills-tabVertical" role="tablist">
                                {tabs.map((val)=>(
                                    ((val === 'Categories' && result?.length >0) || ['Size(mm)', 'Price range'].includes(val)) &&
                                    <li className="nav-item flex-grow mb-4" role="presentation" key={val}>
                                        <a href="javascript:void(0)"
                                            onClick={()=>setselected(val)}
                                            className={`nav-link block sm:text-base text-sm font-semibold text-[#090406] price ${selected===val?'active':''} relative`}id="pills-priceranje" data-bs-toggle="pill" data-bs-target="#pills-pricetab" role="tab"
                                            aria-controls="pills-price" aria-selected="true">{val}
                                        </a>
                                    </li>
                                ))}
                              
                            </ul>
                            <div className="tab-content w-[75%] h-[300px] bg-[#F2F2F3]" id="pills-tabContentVertical">
                                <div className={`tab-pane  px-3 pt-4 ${selected ==='Price range'?'show active fade':'fade'}`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                    <div className="relative">
                                        <div className="pt-3.5 flex justify-between">
                                            <p className="text-xs font-semibold text-[#000000]">₹0</p>
                                            <p className="text-xs font-semibold text-[#000000]">₹ 50,000</p>
                                        </div>
                                        <div className=" mt-3 mb-4">
                                            <div x-data="range()" x-init="mintrigger(); maxtrigger()" className="relative max-w-xl w-full">
                                                <div>
                                                    <PriceSlider setpriceRange={setpriceRange} priceRange={priceRange}/>
                                                </div>    
                                            </div>
                                        </div>
                                    </div>
                                    <div className="px-1 flex items-center">
                                        <div className="relative w-1/2">
                                            <input type="text"
                                                id="minval"
                                                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                                                value={priceRange.minValue}
                                                onChange={(e)=>setpriceRange((state)=>({
                                                    ...state,
                                                    minValue:e.target.value
                                                }))}
                                                className="bg-[#FFFFFF] w-full rounded border border-[#A5A5A5] outline-0 py-1 px-1.5 text-xs6 font-semibold text-[#000000] text-end" />
                                            <p className="text-xs6 font-semibold text-[#000000] absolute top-[5px] left-[5px] bg-[#FFFFFF]">₹</p>
                                        </div>
                                        <span className="text-xs6 font-semibold text-[#000000] px-5">-</span>
                                        <div className="relative w-1/2">
                                            <input 
                                                value={priceRange.maxValue}
                                                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                                                onChange={(e)=>setpriceRange((state)=>({
                                                    ...state,
                                                    maxValue:e.target.value
                                                }))}
                                                type="text" id="maxVal" className="bg-[#FFFFFF] w-full rounded border border-[#A5A5A5] outline-0 py-1 px-1.5 text-xs6 font-semibold text-[#000000] text-end" />
                                            <p className="text-xs6 font-semibold text-[#000000] absolute top-[5px] left-[5px] bg-[#FFFFFF]">₹</p>
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane px-3 pt-4 ${selected ==='Size(mm)'?'show active fade':'fade'}`} id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size">
                                    <div className="flex flex-col items-start px-2.5">
                                        <label htmlFor="Diameter" className="text-xs3 font-normal text-[#555259] pb-1.5">Diameter</label>
                                        <select
                                            onChange={(e) => setSize((state) => ({
                                                ...state,
                                                DIAMETER: e.target.value,
                                            }))}
                                            type="number"
                                            id="Diameter"
                                            value={Size.DIAMETER}
                                            placeholder="Enter Diameter in mm"
                                            className="border border-[#A5A5A5] rounded-md pr-2.5 pl-3 py-1.5 h-[27px] text-xs font-normal text-[#090406] outline-0"
                                        >
                                            <option value="" selected={!Size.DIAMETER}>Select Diameter</option>
                                            {filterParam.DIAMETER && filterParam.DIAMETER.map((item, index) => (
                                                <option key={index} value={item.DIAMETER} selected={Size.DIAMETER== item.DIAMETER}>{item.DIAMETER}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="flex flex-col items-start px-2.5 pt-3.5">
                                        <label htmlFor="length" className="text-xs3 font-normal text-[#555259] pb-1.5">Length</label>
                                        <select
                                            onChange={(e) => {
                                                setSize((state) => ({
                                                    ...state,
                                                    LENGTH: e.target.value,
                                                }));
                                            }}
                                            type="number"
                                            id="length"
                                            className="border border-[#A5A5A5] rounded-md pr-2.5 pl-3 py-1.5 h-[27px] text-xs font-normal text-[#090406] outline-0 placeholder:text-xs placeholder:font-normal placeholder:text-[#A5A5A5]"
                                            placeholder="Enter Length in mm"
                                        >
                                            <option value="" selected={!Size.LENGTH}>Select Length</option>
                                            {filterParam.LENGTH && filterParam.LENGTH.map((item, index) => (
                                                <option key={index} value={item.LENGTH} selected={Size.LENGTH == item.LENGTH}>{item.LENGTH}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                {result?.length > 0 && <div className={`tab-pane px-3 pt-4 ${selected ==='Categories'?'show active fade':'fade'}`} style={{overflow:'auto',height:'300px'}} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                                    <div className=" overflow-auto sidebar">
                                        <div className="overflow-auto sidebar cursor-pointer relative" >
                                            <>{result?.length > 0 && <CustomFilter result={result} Segments={Segments} handleCheckBox={handleCheckBox}/>}</>
                                        </div>
                                    </div>
                                </div>}
                            </div>   
                        </div>                      
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[30%] mr-5">
                                <button 
                                    onClick={()=>{
                                        handleClear()
                                    }}type="button" className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold text-[#555259]" data-bs-dismiss="modal" aria-label="Close">
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button 
                                    onClick={()=>{
                                        handleApply()
                                    }}
                                    type="button" className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold text-[#FFFFFF]" data-bs-dismiss="modal" aria-label="Close">
                                    Apply Filter
                                </button>
                            </div>
                        </div>                       
                    </div>
                </div>
            </Modal>
        </div>
    )
}
